import React from 'react';
import { NavLink } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';
import { MdMoreHoriz } from 'react-icons/md';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function ScanPointsListItem({ scanPoint, eventID }) {
    const history = useHistory();
    const { t } = useTranslation();
    const navigateToScanPoint = () => history.push(`/events/${eventID}/scanpoints/${scanPoint.scanPointID}`);
    // let active = true;

    // Check if scan point is currently active.
    /*if(!scanPoint.timeActiveStart) {
        active = scanPoint.timeActiveEnd ? moment(scanPoint.timeActiveEnd).isAfter(moment()) : true;
    } else if(!scanPoint.timeActiveEnds) {
        active = moment(scanPoint.timeActiveStart).isBefore(moment());
    } else {
        active = moment().isBetween(moment(scanPoint.timeActiveStart), moment(scanPoint.timeActiveEnd))
    }*/

    return (
        <div className="DataListItem row align-items-center" style={{ paddingTop: '20px', paddingBottom: '20px' }}>
            <div className="col-lg-7">
                <span style={{ cursor: 'pointer' }} onClick={navigateToScanPoint}>
                    <span><strong>{scanPoint.name}</strong></span>
                </span>
            </div>
            <div className="col-lg-2">
                {scanPoint.scanCount} {t('scan_points.scans')}
            </div>
            {/*<div className="col-2">
                {active ? 
                    <span><IoIosCheckmarkCircle className="green" style={{ marginRight: '5px', position: 'relative', top: '-2px' }} /> {t("general.active")}</span> :
                    <span><IoIosCloseCircle className="red" style={{ marginRight: '5px', position: 'relative', top: '-2px' }} /> {t("general.inactive")}</span>
                }
            </div>*/}
            <div className="col text-right">
                <Dropdown>
                    <Dropdown.Toggle as="span">
                        <MdMoreHoriz style={{ fontSize: '18px' }} />
                    </Dropdown.Toggle>
                    <Dropdown.Menu alignRight>
                        <li>
                            <NavLink to={`/events/${eventID}/scanpoints/${scanPoint.scanPointID}`} className="dropdown-item">{t('scan_points.browse_scan_data')}</NavLink>
                        </li>
                        <li>
                            <NavLink to={`/events/${eventID}/scanpoints/${scanPoint.scanPointID}/settings`} className="dropdown-item">{t('general.settings')}</NavLink>
                        </li>
                    </Dropdown.Menu>
                </Dropdown>
            </div>
        </div>
    );
}

export default ScanPointsListItem;